
import React from 'react';
import { useTranslation } from 'react-i18next';

// Import all product images per language
import Jaggery_English from '../images/Jaggery_English.png';
import Jaggery_Hindi from '../images/Jaggery_Hindi.png';
import Jaggery_Marathi from '../images/Jaggery_Marathi.png';
import Masala_English from '../images/Masala_English.png';
import Masala_Hindi from '../images/Masala_Hindi.png';
import Masala_Marathi from '../images/Masala_Marathi.png';
import Black_English from '../images/Black_English.png';
import Black_Hindi from '../images/Black_Hindi.png';
import Black_Marathi from '../images/Black_Marathi.png';
import Green_English from '../images/Green_English.png';
import Green_Hindi from '../images/Green_Hindi.png';
import Green_Marathi from '../images/Green_Marathi.png';
import Lemon_English from '../images/Lemon_English.png';
import Lemon_Hindi from '../images/Lemon_Hindi.png';
import Lemon_Marathi from '../images/Lemon_Marathi.png';
import Tulsi_English from '../images/Tulsi_English.png';
import Tulsi_Hindi from '../images/Tulsi_Hindi.png';
import Tulsi_Marathi from '../images/Tulsi_Marathi.png';
import Sugar_Free_Hindi from '../images/Sugar_Free_Hindi.png';
import Sugar_Free_English from '../images/Sugar_Free_English.png';
import Sugar_Free_Marathi from '../images/Sugar_Free_Marathi.png';
import Choco_English from '../images/Choco_English_.png';
import Choco_Hindi from '../images/Choco_Hindi.png';
import Choco_Marathi from '../images/Choco_Marathi.png';
import Coffee_English from '../images/Coffee_English.png';
import Coffee_Hindi from '../images/Coffee_Hindi.png';
import Coffee_Marathi from '../images/Coffee_Marathi.png';

interface ProductCardProps {
  product: string;
}

const langSuffix: Record<string, string> = {
  en: 'English',
  hi: 'Hindi',
  mr: 'Marathi',
};

// Map of product key -> { English, Hindi, Marathi } images
const imageMap: Record<string, Record<string, string>> = {
  jaggeryTea: { English: Jaggery_English, Hindi: Jaggery_Hindi, Marathi: Jaggery_Marathi },
  masalaTea: { English: Masala_English, Hindi: Masala_Hindi, Marathi: Masala_Marathi },
  blackTea: { English: Black_English, Hindi: Black_Hindi, Marathi: Black_Marathi },
  greenTea: { English: Green_English, Hindi: Green_Hindi, Marathi: Green_Marathi },
  lemonTea: { English: Lemon_English, Hindi: Lemon_Hindi, Marathi: Lemon_Marathi },
  tulasiTea: { English: Tulsi_English, Hindi: Tulsi_Hindi, Marathi: Tulsi_Marathi },
  sugarFreeTea: { English: Sugar_Free_English, Hindi: Sugar_Free_Hindi, Marathi: Sugar_Free_Marathi },
  chocolateTea: { English: Choco_English, Hindi: Choco_Hindi, Marathi: Choco_Marathi },
  coffee: { English: Coffee_English, Hindi: Coffee_Hindi, Marathi: Coffee_Marathi },
};

const ProductCard: React.FC<ProductCardProps> = ({ product }) => {
  const { t, i18n } = useTranslation();
  const lang = langSuffix[i18n.language] || 'English';

  const productImage = imageMap[product]?.[lang] || imageMap['jaggeryTea']['English'];

  return (
    <div className="product-card">
      <div className="image-wrapper">
        <img src={productImage} alt={t(`product_${product}`)} loading="lazy" width={300} height={300} />
      </div>
      <div className="content">
        <h3 className="product-title">{t(`product_${product}`)}</h3>
        <p className="product-description">{t(`product_desc_${product}`)}</p>
      </div>
    </div>
  );
};

export default ProductCard;